import React from 'react';
import { useTranslation } from 'react-i18next';
import SocialShareButtons from '../../SocialShareButtons';
import CopyButton from './CopyButton';
import s from './DesktopSharePopup.scss';
var DesktopSharePopup = function (_a) {
    var url = _a.url, title = _a.title, thumbCode = _a.thumbCode, embedCode = _a.embedCode, media = _a.media, biData = _a.biData;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t('share.shareOnSocial')),
        React.createElement(SocialShareButtons, { url: url, title: title || url, media: media, buttons: ['facebook', 'twitter', 'tumblr', 'pinterest'], iconSize: 42, iconBgColor: "#0e0d20" // L8
            , logoFillColor: "#00e59b" // G3
            , biData: biData }),
        React.createElement("div", { className: s['copy-title'] }, t('share.linkUrl')),
        React.createElement(CopyButton, { text: url, biData: biData }),
        false && (
        // disabled until editor supports thumbcodes
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['copy-title'] }, t('share.thumb')),
            React.createElement(CopyButton, { text: thumbCode || '' }))),
        embedCode && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['copy-title'] }, t('share.embed')),
            React.createElement(CopyButton, { text: embedCode, biData: biData })))));
};
DesktopSharePopup.displayName = 'DesktopSharePopup';
export default DesktopSharePopup;
//# sourceMappingURL=DesktopSharePopup.js.map